<template>
    <div class="ActionCard" :class="{'ActionCard--flexible': !fixedLayout, 'ActionCard--default pb-4': !action}">
        <template v-if="!$slots.default">
            <div class="ActionCard__in">
                <div class="ActionCard__logo">
                    <img v-if="data.img" :src="data.img.src" :alt="data.img.alt" :title="data.img.title">
                    <img v-if="data.photo" :src="data.photo.src" :alt="data.photo.alt" :title="data.photo.title">
                </div>
                <div>
                    <div class="ActionCard__name">
                        <a :href="data.url" v-if="data.url">{{ data.name }}</a>
                        <span v-else>{{ data.name }}</span>
                    </div>
                    <div class="city_block" v-if="data.city && data.city.cityValue">
                      <span style="font-weight: 400; font-size: 1em" class="ActionCard__name">
                        {{ data.city.cityTitle + ':' }}
                      </span>
                      <span style="font-weight: 400; font-size: 1em" class="ActionCard__name">
                        {{ data.city.cityValue }}
                      </span>
                  </div>
                    <div class="ActionCard__description">
                        {{ data.description }}
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
        <div v-if="$slots.footer" class="ActionCard__footer">
            <slot name="footer"></slot>
          <div class="profile_soc_icons">
            <a v-if="data.instagram" :href="data.instagram">
              <div class="profile_soc_icon">
                <svg width="40" height="40">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/local/templates/main/img/icons/sprite.svg#instagram"></use>
                </svg>
              </div>
            </a>
            <a v-if="data.facebook" :href="data.facebook">
              <div class="profile_soc_icon">
                <svg width="40" height="40">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/local/templates/main/img/icons/sprite.svg#facebook"></use>
                </svg>
              </div>
            </a>
            <a v-if="data.youtube" :href="data.youtube">
              <div class="profile_soc_icon">
                <svg width="40" height="40" id="profile_soc_youtube_icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/local/templates/main/img/icons/sprite.svg#youtube"></use>
                </svg>
              </div>
            </a>
          </div>
        </div>
        <div class="ActionCard__button" v-if="action&&actionName">
            <ABtn
              :label="actionName"
              color="#fff"
              :bg="actionStatus=='disabled'?'var(--c-primary-200)':'var(--c-secondary-200)'"
              @click.native="action"
            />
        </div>
    </div>
</template>

<script>
/**
 * https://i.imgur.com/CgNnQw1.png
 */

import each from 'lodash/each';
import {ABtn} from "../ui";

export default {
    name: "ActionCard",
    props: {
        data: {
            type: Object,
            validator(value) {
                const dataProperties = ['name', 'url', 'img', 'description']
                each(dataProperties, prop => {
                    if (!value.hasOwnProperty(prop)) {
                        console.info(`ActionCard.vue - property ${prop} is undefined`)
                    }
                })
            }
        },
        action: Function,
        actionName: String,
        actionStatus: String,
        fixedLayout: {
            // prop to check if component has fixed width/height.
            // adaptive width could be used for mobile screens
            type: Boolean,
            default: true
        }
    },
    components: {
        ABtn
    }
}
</script>

<style scoped lang="scss">
.ActionCard {
    background: #FFFFFF;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 rem(40) rgba(0, 0, 0, 0.1);
    border-radius: rem(6);
    z-index: 10;

    &--default {
        @include mobile {
            padding-bottom: rem(25);
        }
    }

    &--flexible {
        padding: 0 15px;

        @include tabletOnly {
            display: flex;
            align-items: stretch;
        }
    }

    &__in {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: rem(40);
        gap: rem(30);

        .ActionCard--flexible & {
            @include tabletOnly {
                flex-direction: row;
                align-items: center;
                padding: 0;
            }
        }
    }

    &__logo {
        max-width: rem(140);
        min-height: rem(72);

        .ActionCard--flexible & {
            @include tabletOnly {
                margin-bottom: 0;
                min-width: rem(75);
            }
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &__name {
        font-weight: 600;
        font-size: rem(22);
        line-height: 127%;
        color: var(--c-gray-120);
        margin-bottom: rem(12);
        text-align: center;

        a {
            font: inherit;
            color: inherit;
        }
    }

    &__description {
        font-weight: 400;
        font-size: rem(12);
        line-height: rem(16);
        color: var(--c-gray-500);
        margin-bottom: rem(10);
        text-align: center;
    }

    &__footer {

        .ActionCard--flexible & {
            margin-left: -15px;
            width: calc(100% + 30px);

            @include tabletOnly {
                margin-left: unset;
                width: 100%;
            }
        }
    }

    &__button {
        .ActionCard--flexible & {
            margin-left: -15px;
            width: calc(100% + 30px);

            @include tabletOnly {
                display: flex;
                align-items: center;
                margin-left: unset;
                width: 100%;

                ::v-deep .a-btn {
                    border-radius: 6px;
                }
            }
        }
    }

    ::v-deep .a-btn {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

  .profile_soc_icons {
    display: flex;
    justify-content: space-around;
  }

  .profile_soc_icon {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #profile_soc_youtube_icon {
    transform: scale(1.33);
  }

  .city_block {
    display: flex;
    gap: 10px;
    justify-content: center;
  }
}
</style>